import React from 'react'
import BaseDateRangeReport from './BaseDateRangedReport'

export default () => <BaseDateRangeReport
  reportHeader = "Card Spend Report"
  reportDownloadName = "cardSpendReport"
  apiReportName = "cardSpendReport"
  downloadOnly = {true}
/>
